module Meevo.Plugins.MerchantAccountsOnboardingTesting {
    "use strict";

    interface ITestConfiguration {
        enabled: boolean;
        testCases: ITestCase[];
    }

    interface ITestCase {
        displayName: string;
        action: AdyenBalanceOnboardingApiEndpointEnum;
        statusCode: number;
        induceLegalEntityError: boolean;
        subErrorCode: string;
        induceTimeout: boolean;
        responseBody: string;
        data?: {
            [key: string]: any;
        }
    }

    enum AdyenBalanceOnboardingApiEndpointEnum {
        None = 0,
        CreateLegalEntity,
        CreateAccountHolder,
        CreateBalanceAccount,
        CreateBusinessLine,
        CreateStore,
        CreatePaymentMethods,
        GetHostedOnboardingLink,
        GetLegalEntity,
        PatchLegalEntity,
        SalesForceNotification,
    };

    export class TestConfigurationOnboardingSection extends Meevo.Components.CommonClasses.CommonSectionBase {
        endpoints = AdyenBalanceOnboardingApiEndpointEnum;
        cardTypes = ["", "amex", "mc", "visa", "diners", "discover", "interac_card"];
        protected busyService: Meevo.Components.Busy.IBusyService;

        public model: ITestConfiguration = {
            enabled: false,
            testCases: []
        };
        public allAvailableActions: any[] = [
            { name: "", value: AdyenBalanceOnboardingApiEndpointEnum.None },
            { name: "Create Legal Entity", value: AdyenBalanceOnboardingApiEndpointEnum.CreateLegalEntity },
            { name: "Create Account Holder", value: AdyenBalanceOnboardingApiEndpointEnum.CreateAccountHolder },
            { name: "Create Balance Account", value: AdyenBalanceOnboardingApiEndpointEnum.CreateBalanceAccount },
            { name: "Create Business Line", value: AdyenBalanceOnboardingApiEndpointEnum.CreateBusinessLine },
            { name: "Create Store", value: AdyenBalanceOnboardingApiEndpointEnum.CreateStore },
            { name: "Create Payment Methods", value: AdyenBalanceOnboardingApiEndpointEnum.CreatePaymentMethods },
            { name: "Get Hosted Onboarding Link", value: AdyenBalanceOnboardingApiEndpointEnum.GetHostedOnboardingLink },
            { name: "Get Legal Entity", value: AdyenBalanceOnboardingApiEndpointEnum.GetLegalEntity },
            { name: "Patch Legal Entity", value: AdyenBalanceOnboardingApiEndpointEnum.PatchLegalEntity },
            { name: "SalesForce Notification", value: AdyenBalanceOnboardingApiEndpointEnum.SalesForceNotification },
        ];
        public allStatusCodes: any[] = [
            { name: "422: Unprocessable Content", value: 422 },
            { name: "200: OK", value: 200 },
        ];

        constructor(protected params: Meevo.Model.ISectionParamsCommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $rootScope: ng.IRootScopeService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $translate: angular.translate.ITranslateService,
            protected $q: angular.IQService,
            protected context: MerchantAccountsOnboardingTestingContext) {
            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.noun,
                params.identityService,
                params.sectionSecurityKey
            );

            this.busyService = params.busyService;
        }

        addNewTestCase() {
            this.model.testCases.push({
                displayName: "",
                action: AdyenBalanceOnboardingApiEndpointEnum.None,
                statusCode: 422,
                induceLegalEntityError: false,
                subErrorCode: "",
                responseBody: "",
                induceTimeout: false,
                data: {}
            });
        }

        deleteTestCase(testCase: ITestCase) {
            var ndx = _.findIndex(this.model.testCases, (item: ITestCase) => {
                return item === testCase;
            });
            this.model.testCases.splice(ndx, 1);
        }

        preSave(): any {
            for (let inTestCase of this.model.testCases) {
                let testCase = <any>inTestCase;
                if (testCase.action !== AdyenBalanceOnboardingApiEndpointEnum.CreateLegalEntity) {
                    testCase.induceLegalEntityError = false;
                    testCase.subErrorCode = "";
                }
                if (testCase.action !== AdyenBalanceOnboardingApiEndpointEnum.GetLegalEntity) {
                    testCase.statusCode = 422;
                }
            }
            super.preSave();
        }
    }
}